import { render } from "./KpiGroupDetails.vue?vue&type=template&id=9683e4e4&scoped=true"
import script from "./KpiGroupDetails.vue?vue&type=script&lang=js"
export * from "./KpiGroupDetails.vue?vue&type=script&lang=js"

import "./KpiGroupDetails.vue?vue&type=style&index=0&id=9683e4e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9683e4e4"]])

export default __exports__